import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { ProfilePage } from 'src/app/modules/user/page/profile/profile.page';
import { InvoicesPage } from 'src/app/modules/user/page/invoices/invoices.page';
import { BrowserHelper } from 'src/app/core/helper/browser.helper';
import { IntroJsService } from 'src/app/data/service/intro-js.service';
import { ServiceHelper } from 'src/app/core/helper/services.helper';

@Component({
  selector: 'app-header-popover-menu',
  templateUrl: './header-popover-menu.component.html',
  styleUrls: ['./header-popover-menu.component.scss'],
})
export class HeaderPopoverMenuComponent implements OnInit {

  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private introJsSvc: IntroJsService,
    private browserHelper: BrowserHelper,
    private popoverCtrl: PopoverController,
    private authSvc: AuthenticationService,
  ) { }

  ngOnInit() {}

  close(a: number) {
    this.popoverCtrl.dismiss();
    switch(a) {
      case 1:
        ServiceHelper.navCtrl.navigateRoot('admin/home');
        break;
      case 2: this.openProfile(); break;
      case 3: this.openBilling(); break;
      case 4:
        this.introJsSvc.resetTutorials();
        break;
      case 5:
        this.browserHelper.openUrl('https://raffle-rocket.com/support/');
        break;
      case 6:
        this.authSvc.logout();
        this.navCtrl.navigateRoot('auth/login');
        break;
    }
  }

  async openProfile() {
    const modal = await this.modalCtrl.create({
      component: ProfilePage,
      backdropDismiss: false
    });
    await modal.present();
  }

  async openBilling() {
    const modal = await this.modalCtrl.create({
      component: InvoicesPage,
      backdropDismiss: false
    });
    await modal.present();
  }
}
